export function calculateFine({ resultUSDT, plan }) {
    if (!plan) return 0;
    if (resultUSDT >= plan) return 0;

    const d = (plan - resultUSDT) / plan;
    const e = d / 2;
    const f = resultUSDT - resultUSDT * 0.9;
    const g = f - (f * e);
    const h = Math.max(0, f - g);

    return h;
}